var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 18,
    viewBox: "0 0 4 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00019 10.0004C2.55258 10.0004 3.00037 9.55258 3.00037 9.00019C3.00037 8.4478 2.55258 8 2.00019 8C1.4478 8 1 8.4478 1 9.00019C1 9.55258 1.4478 10.0004 2.00019 10.0004Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.00019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00019 3.00037C2.55258 3.00037 3.00037 2.55258 3.00037 2.00019C3.00037 1.4478 2.55258 1 2.00019 1C1.4478 1 1 1.4478 1 2.00019C1 2.55258 1.4478 3.00037 2.00019 3.00037Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.00019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00019 17.0043C2.55258 17.0043 3.00037 16.5565 3.00037 16.0041C3.00037 15.4517 2.55258 15.0039 2.00019 15.0039C1.4478 15.0039 1 15.4517 1 16.0041C1 16.5565 1.4478 17.0043 2.00019 17.0043Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.00019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/icon-more.e904408bd2d827888b62b55e4407c674.svg";
export { ForwardRef as ReactComponent };